export interface PeriodicElement
{
  name: string;
  symbol: string;
  groupName: string;
  number: number;
  mass: number;
  period: number;
  group: number | string;
  melting: number | string;
  boiling: number | string;
  density: number | string;
  electronegativity: number | string;
  radius: number | string;
  valence: number | string;
  specificheat: number | string;
  comment: string;
}

export function elements(): PeriodicElement[] {
  return [
    {
      name: 'hydrogen',
      symbol: 'H',
      groupName: 'other-nonmetal',
      number: 1,
      mass: 1.008,
      period: 1,
      group: 1,
      melting: 14.01,
      boiling: 20.28,
      density: 0.00008988,
      electronegativity: 2.2,
      radius: 25,
      valence: 1,
      specificheat: 14.304,
      comment: '',
    },
    {
      name: 'helium',
      symbol: 'He',
      groupName: 'noble-gas',
      number: 2,
      mass: 4.002602,
      period: 1,
      group: 18,
      melting: 0.95,
      boiling: 4.22,
      density: 0.0001785,
      electronegativity: '',
      radius: 31,
      valence: 2,
      specificheat: 5.193,
      comment: '',
    },
    {
      name: 'lithium',
      symbol: 'Li',
      groupName: 'alkali-metal',
      number: 3,
      mass: 6.94,
      period: 2,
      group: 1,
      melting: 453.69,
      boiling: 1560,
      density: 0.534,
      electronegativity: 0.98,
      radius: 145,
      valence: 1,
      specificheat: 3.582,
      comment: '',
    },
    {
      name: 'beryllium',
      symbol: 'Be',
      groupName: 'alkaline-earth-metal',
      number: 4,
      mass: 9.012,
      period: 2,
      group: 2,
      melting: 1560,
      boiling: 2742,
      density: 1.85,
      electronegativity: 1.57,
      radius: 105,
      valence: 2,
      specificheat: 1.825,
      comment: '',
    },
    {
      name: 'boron',
      symbol: 'B',
      groupName: 'metalloid',
      number: 5,
      mass: 10.81,
      period: 2,
      group: 13,
      melting: 2349,
      boiling: 4200,
      density: 2.34,
      electronegativity: 2.04,
      radius: '',
      valence: '',
      specificheat: 1.026,
      comment: '',
    },
    {
      name: 'carbon',
      symbol: 'C',
      groupName: 'other-nonmetal',
      number: 6,
      mass: 12.011,
      period: 2,
      group: 14,
      melting: 3800,
      boiling: 4300,
      density: 2.267,
      electronegativity: 2.55,
      radius: '',
      valence: '',
      specificheat: 0.709,
      comment: '',
    },
    {
      name: 'nitrogen',
      symbol: 'N',
      groupName: 'other-nonmetal',
      number: 7,
      mass: 14.007,
      period: 2,
      group: 15,
      melting: 63.15,
      boiling: 77.36,
      density: 0.0012506,
      electronegativity: 3.04,
      radius: '',
      valence: '',
      specificheat: 1.04,
      comment: '',
    },
    {
      name: 'oxygen',
      symbol: 'O',
      groupName: 'other-nonmetal',
      number: 8,
      mass: 15.999,
      period: 2,
      group: 16,
      melting: 54.36,
      boiling: 90.2,
      density: 0.001429,
      electronegativity: 3.44,
      radius: '',
      valence: '',
      specificheat: 0.918,
      comment: '',
    },
    {
      name: 'fluorine',
      symbol: 'F',
      groupName: 'halogen',
      number: 9,
      mass: 18.998,
      period: 2,
      group: 17,
      melting: 53.53,
      boiling: 85.03,
      density: 0.001696,
      electronegativity: 3.98,
      radius: '',
      valence: '',
      specificheat: 0.824,
      comment: '',
    },
    {
      name: 'neon',
      symbol: 'Ne',
      groupName: 'noble-gas',
      number: 10,
      mass: 20.1797,
      period: 2,
      group: 18,
      melting: 24.56,
      boiling: 27.07,
      density: 0.0008999,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: 1.03,
      comment: '',
    },
    {
      name: 'sodium',
      symbol: 'Na',
      groupName: 'alkali-metal',
      number: 11,
      mass: 22.989,
      period: 3,
      group: 1,
      melting: 370.87,
      boiling: 1156,
      density: 0.971,
      electronegativity: 0.93,
      radius: '',
      valence: '',
      specificheat: 1.228,
      comment: '',
    },
    {
      name: 'magnesium',
      symbol: 'Mg',
      groupName: 'alkaline-earth-metal',
      number: 12,
      mass: 24.305,
      period: 3,
      group: 2,
      melting: 923,
      boiling: 1363,
      density: 1.738,
      electronegativity: 1.31,
      radius: '',
      valence: '',
      specificheat: 1.023,
      comment: '',
    },
    {
      name: 'aluminium',
      symbol: 'Al',
      groupName: 'post-transition-metal',
      number: 13,
      mass: 26.982,
      period: 3,
      group: 13,
      melting: 933.47,
      boiling: 2792,
      density: 2.698,
      electronegativity: 1.61,
      radius: '',
      valence: '',
      specificheat: 0.897,
      comment: '',
    },
    {
      name: 'silicon',
      symbol: 'Si',
      groupName: 'metalloid',
      number: 14,
      mass: 28.085,
      period: 3,
      group: 14,
      melting: 1687,
      boiling: 3538,
      density: 2.3296,
      electronegativity: 1.9,
      radius: '',
      valence: '',
      specificheat: 0.705,
      comment: '',
    },
    {
      name: 'phosphorus',
      symbol: 'P',
      groupName: 'other-nonmetal',
      number: 15,
      mass: 30.974,
      period: 3,
      group: 15,
      melting: 317.3,
      boiling: 550,
      density: 1.82,
      electronegativity: 2.19,
      radius: '',
      valence: '',
      specificheat: 0.769,
      comment: '',
    },
    {
      name: 'sulfur',
      symbol: 'S',
      groupName: 'other-nonmetal',
      number: 16,
      mass: 32.06,
      period: 3,
      group: 16,
      melting: 388.36,
      boiling: 717.87,
      density: 2.067,
      electronegativity: 2.58,
      radius: '',
      valence: '',
      specificheat: 0.71,
      comment: '',
    },
    {
      name: 'chlorine',
      symbol: 'Cl',
      groupName: 'halogen',
      number: 17,
      mass: 35.45,
      period: 3,
      group: 17,
      melting: 171.6,
      boiling: 239.11,
      density: 0.003214,
      electronegativity: 3.16,
      radius: '',
      valence: '',
      specificheat: 0.479,
      comment: '',
    },
    {
      name: 'argon',
      symbol: 'Ar',
      groupName: 'noble-gas',
      number: 18,
      mass: 39.948,
      period: 3,
      group: 18,
      melting: 83.8,
      boiling: 87.3,
      density: 0.0017837,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: 0.52,
      comment: '',
    },
    {
      name: 'potassium',
      symbol: 'K',
      groupName: 'alkali-metal',
      number: 19,
      mass: 39.0983,
      period: 4,
      group: 1,
      melting: 336.53,
      boiling: 1032,
      density: 0.862,
      electronegativity: 0.82,
      radius: '',
      valence: '',
      specificheat: 0.757,
      comment: '',
    },
    {
      name: 'calcium',
      symbol: 'Ca',
      groupName: 'alkaline-earth-metal',
      number: 20,
      mass: 40.078,
      period: 4,
      group: 2,
      melting: 1115,
      boiling: 1757,
      density: 1.54,
      electronegativity: 1,
      radius: '',
      valence: '',
      specificheat: 0.647,
      comment: '',
    },
    {
      name: 'scandium',
      symbol: 'Sc',
      groupName: 'transition-metal',
      number: 21,
      mass: 44.956,
      period: 4,
      group: 3,
      melting: 1814,
      boiling: 3109,
      density: 2.989,
      electronegativity: 1.36,
      radius: '',
      valence: '',
      specificheat: 0.568,
      comment: '',
    },
    {
      name: 'titanium',
      symbol: 'Ti',
      groupName: 'transition-metal',
      number: 22,
      mass: 47.867,
      period: 4,
      group: 4,
      melting: 1941,
      boiling: 3560,
      density: 4.54,
      electronegativity: 1.54,
      radius: '',
      valence: '',
      specificheat: 0.523,
      comment: '',
    },
    {
      name: 'vandium',
      symbol: 'V',
      groupName: 'transition-metal',
      number: 23,
      mass: 50.9415,
      period: 4,
      group: 5,
      melting: 2183,
      boiling: 3680,
      density: 6.11,
      electronegativity: 1.63,
      radius: '',
      valence: '',
      specificheat: 0.489,
      comment: '',
    },
    {
      name: 'chromium',
      symbol: 'Cr',
      groupName: 'transition-metal',
      number: 24,
      mass: 51.9961,
      period: 4,
      group: 6,
      melting: 2180,
      boiling: 2944,
      density: 7.15,
      electronegativity: 1.66,
      radius: '',
      valence: '',
      specificheat: 0.449,
      comment: '',
    },
    {
      name: 'manganese',
      symbol: 'Mn',
      groupName: 'transition-metal',
      number: 25,
      mass: 54.938,
      period: 4,
      group: 7,
      melting: 1519,
      boiling: 2334,
      density: 7.44,
      electronegativity: 1.55,
      radius: '',
      valence: '',
      specificheat: 0.479,
      comment: '',
    },
    {
      name: 'iron',
      symbol: 'Fe',
      groupName: 'transition-metal',
      number: 26,
      mass: 55.845,
      period: 4,
      group: 8,
      melting: 1811,
      boiling: 3134,
      density: 7.874,
      electronegativity: 1.83,
      radius: '',
      valence: '',
      specificheat: 0.449,
      comment: '',
    },
    {
      name: 'cobalt',
      symbol: 'Co',
      groupName: 'transition-metal',
      number: 27,
      mass: 58.933,
      period: 4,
      group: 9,
      melting: 1768,
      boiling: 3200,
      density: 8.86,
      electronegativity: 1.88,
      radius: '',
      valence: '',
      specificheat: 0.421,
      comment: '',
    },
    {
      name: 'nickel',
      symbol: 'Ni',
      groupName: 'transition-metal',
      number: 28,
      mass: 58.6934,
      period: 4,
      group: 10,
      melting: 1728,
      boiling: 3186,
      density: 8.912,
      electronegativity: 1.91,
      radius: '',
      valence: '',
      specificheat: 0.444,
      comment: '',
    },
    {
      name: 'copper',
      symbol: 'Cu',
      groupName: 'transition-metal',
      number: 29,
      mass: 63.546,
      period: 4,
      group: 11,
      melting: 1357.77,
      boiling: 2835,
      density: 8.96,
      electronegativity: 1.9,
      radius: '',
      valence: '',
      specificheat: 0.385,
      comment: '',
    },
    {
      name: 'zinc',
      symbol: 'Zn',
      groupName: 'transition-metal',
      number: 30,
      mass: 65.38,
      period: 4,
      group: 12,
      melting: 692.88,
      boiling: 1180,
      density: 7.134,
      electronegativity: 1.65,
      radius: '',
      valence: '',
      specificheat: 0.388,
      comment: '',
    },
    {
      name: 'gallium',
      symbol: 'Ga',
      groupName: 'post-transition-metal',
      number: 31,
      mass: 69.723,
      period: 4,
      group: 13,
      melting: 302.9146,
      boiling: 2477,
      density: 5.907,
      electronegativity: 1.81,
      radius: '',
      valence: '',
      specificheat: 0.371,
      comment: '',
    },
    {
      name: 'germanium',
      symbol: 'Ge',
      groupName: 'metalloid',
      number: 32,
      mass: 72.63,
      period: 4,
      group: 14,
      melting: 1211.4,
      boiling: 3106,
      density: 5.323,
      electronegativity: 2.01,
      radius: '',
      valence: '',
      specificheat: 0.32,
      comment: '',
    },
    {
      name: 'arsenic',
      symbol: 'As',
      groupName: 'metalloid',
      number: 33,
      mass: 74.921,
      period: 4,
      group: 15,
      melting: 1090,
      boiling: 887,
      density: 5.776,
      electronegativity: 2.18,
      radius: '',
      valence: '',
      specificheat: 0.329,
      comment: '',
    },
    {
      name: 'selenium',
      symbol: 'Se',
      groupName: 'other-nonmetal',
      number: 34,
      mass: 78.971,
      period: 4,
      group: 16,
      melting: 453,
      boiling: 958,
      density: 4.809,
      electronegativity: 2.55,
      radius: '',
      valence: '',
      specificheat: 0.321,
      comment: '',
    },
    {
      name: 'bromine',
      symbol: 'Br',
      groupName: 'halogen',
      number: 35,
      mass: 79.904,
      period: 4,
      group: 17,
      melting: 265.8,
      boiling: 332.0,
      density: 3.122,
      electronegativity: 2.96,
      radius: '',
      valence: '',
      specificheat: 0.474,
      comment: '',
    },
    {
      name: 'krypton',
      symbol: 'Kr',
      groupName: 'noble-gas',
      number: 36,
      mass: 83.798,
      period: 4,
      group: 18,
      melting: 115.79,
      boiling: 119.93,
      density: 0.003733,
      electronegativity: 3,
      radius: '',
      valence: '',
      specificheat: 0.248,
      comment: '',
    },
    {
      name: 'rubidium',
      symbol: 'Rb',
      groupName: 'alkali-metal',
      number: 37,
      mass: 85.4678,
      period: 5,
      group: 1,
      melting: 312.46,
      boiling: 961,
      density: 1.532,
      electronegativity: 0.82,
      radius: '',
      valence: '',
      specificheat: 0.363,
      comment: '',
    },
    {
      name: 'strontium',
      symbol: 'Sr',
      groupName: 'alkaline-earth-metal',
      number: 38,
      mass: 87.62,
      period: 5,
      group: 2,
      melting: 1050,
      boiling: 1655,
      density: 2.64,
      electronegativity: 0.95,
      radius: '',
      valence: '',
      specificheat: 0.301,
      comment: '',
    },
    {
      name: 'yttrium',
      symbol: 'Y',
      groupName: 'transition-metal',
      number: 39,
      mass: 88.906,
      period: 5,
      group: 3,
      melting: 1799,
      boiling: 3609,
      density: 4.469,
      electronegativity: 1.22,
      radius: '',
      valence: '',
      specificheat: 0.298,
      comment: '',
    },
    {
      name: 'zirconium',
      symbol: 'Zr',
      groupName: 'transition-metal',
      number: 40,
      mass: 91.224,
      period: 5,
      group: 4,
      melting: 2128,
      boiling: 4682,
      density: 6.506,
      electronegativity: 1.33,
      radius: '',
      valence: '',
      specificheat: 0.278,
      comment: '',
    },
    {
      name: 'niobium',
      symbol: 'Nb',
      groupName: 'transition-metal',
      number: 41,
      mass: 92.9064,
      period: 5,
      group: 5,
      melting: 2750,
      boiling: 5017,
      density: 8.57,
      electronegativity: 1.6,
      radius: '',
      valence: '',
      specificheat: 0.265,
      comment: '',
    },
    {
      name: 'molybdenum',
      symbol: 'Mo',
      groupName: 'transition-metal',
      number: 42,
      mass: 95.95,
      period: 5,
      group: 6,
      melting: 2896,
      boiling: 4912,
      density: 10.28,
      electronegativity: 2.16,
      radius: '',
      valence: '',
      specificheat: 0.251,
      comment: '',
    },
    {
      name: 'technetium',
      symbol: 'Tc',
      groupName: 'transition-metal',
      number: 43,
      mass: 97,
      period: 5,
      group: 7,
      melting: 2430,
      boiling: 4538,
      density: 11.5,
      electronegativity: 1.9,
      radius: '',
      valence: '',
      specificheat: 0.63,
      comment: '',
    },
    {
      name: 'ruthenium',
      symbol: 'Ru',
      groupName: 'transition-metal',
      number: 44,
      mass: 101.07,
      period: 5,
      group: 8,
      melting: 2607,
      boiling: 4423,
      density: 12.37,
      electronegativity: 2.2,
      radius: '',
      valence: '',
      specificheat: 0.238,
      comment: '',
    },
    {
      name: 'rhodium',
      symbol: 'Rh',
      groupName: 'transition-metal',
      number: 45,
      mass: 102.9055,
      period: 5,
      group: 9,
      melting: 2237,
      boiling: 3968,
      density: 12.41,
      electronegativity: 2.28,
      radius: '',
      valence: '',
      specificheat: 0.243,
      comment: '',
    },
    {
      name: 'palladium',
      symbol: 'Pd',
      groupName: 'transition-metal',
      number: 46,
      mass: 106.42,
      period: 5,
      group: 10,
      melting: 1828.05,
      boiling: 3236,
      density: 12.02,
      electronegativity: 2.2,
      radius: '',
      valence: '',
      specificheat: 0.244,
      comment: '',
    },
    {
      name: 'silver',
      symbol: 'Ag',
      groupName: 'transition-metal',
      number: 47,
      mass: 107.8682,
      period: 5,
      group: 11,
      melting: 1234.93,
      boiling: 2435,
      density: 10.501,
      electronegativity: 1.93,
      radius: '',
      valence: '',
      specificheat: 0.235,
      comment: '',
    },
    {
      name: 'cadmium',
      symbol: 'Cd',
      groupName: 'transition-metal',
      number: 48,
      mass: 112.414,
      period: 5,
      group: 12,
      melting: 594.22,
      boiling: 1040,
      density: 8.69,
      electronegativity: 1.69,
      radius: '',
      valence: '',
      specificheat: 0.232,
      comment: '',
    },
    {
      name: 'indium',
      symbol: 'In',
      groupName: 'post-transition-metal',
      number: 49,
      mass: 114.818,
      period: 5,
      group: 13,
      melting: 429.75,
      boiling: 2345,
      density: 7.31,
      electronegativity: 1.78,
      radius: '',
      valence: '',
      specificheat: 0.233,
      comment: '',
    },
    {
      name: 'tin',
      symbol: 'Sn',
      groupName: 'post-transition-metal',
      number: 50,
      mass: 118.71,
      period: 5,
      group: 14,
      melting: 505.08,
      boiling: 2875,
      density: 7.287,
      electronegativity: 1.96,
      radius: '',
      valence: '',
      specificheat: 0.228,
      comment: '',
    },
    {
      name: 'antimony',
      symbol: 'Sb',
      groupName: 'metalloid',
      number: 51,
      mass: 121.76,
      period: 5,
      group: 15,
      melting: 903.78,
      boiling: 1860,
      density: 6.685,
      electronegativity: 2.05,
      radius: '',
      valence: '',
      specificheat: 0.207,
      comment: '',
    },
    {
      name: 'tellurium',
      symbol: 'Te',
      groupName: 'metalloid',
      number: 52,
      mass: 127.6,
      period: 5,
      group: 16,
      melting: 722.66,
      boiling: 1261,
      density: 6.232,
      electronegativity: 2.1,
      radius: '',
      valence: '',
      specificheat: 0.202,
      comment: '',
    },
    {
      name: 'iodine',
      symbol: 'I',
      groupName: 'halogen',
      number: 53,
      mass: 126.90447,
      period: 5,
      group: 17,
      melting: 386.85,
      boiling: 457.4,
      density: 4.93,
      electronegativity: 2.66,
      radius: '',
      valence: '',
      specificheat: 0.214,
      comment: '',
    },
    {
      name: 'xenon',
      symbol: 'Xe',
      groupName: 'noble-gas',
      number: 54,
      mass: 131.293,
      period: 5,
      group: 18,
      melting: 161.4,
      boiling: 165.03,
      density: 0.005887,
      electronegativity: 2.6,
      radius: '',
      valence: '',
      specificheat: 0.158,
      comment: '',
    },
    {
      name: 'caesium',
      symbol: 'Cs',
      groupName: 'alkali-metal',
      number: 55,
      mass: 132.9055,
      period: 6,
      group: 1,
      melting: 301.59,
      boiling: 944,
      density: 1.873,
      electronegativity: 0.79,
      radius: '',
      valence: '',
      specificheat: 0.242,
      comment: '',
    },
    {
      name: 'barium',
      symbol: 'Ba',
      groupName: 'alkaline-earth-metal',
      number: 56,
      mass: 137.327,
      period: 6,
      group: 2,
      melting: 1000,
      boiling: 2170,
      density: 3.594,
      electronegativity: 0.89,
      radius: '',
      valence: '',
      specificheat: 0.204,
      comment: '',
    },
    {
      name: 'Lanthanum',
      symbol: 'La',
      groupName: 'lanthanoid',
      number: 57,
      mass: 138.9055,
      period: 6,
      group: '',
      melting: 1193,
      boiling: 3737,
      density: 6.145,
      electronegativity: 1.1,
      radius: '',
      valence: '',
      specificheat: 0.195,
      comment: '',
    },
    {
      name: 'cerium',
      symbol: 'Ce',
      groupName: 'lanthanoid',
      number: 58,
      mass: 140.116,
      period: 6,
      group: '',
      melting: 1068,
      boiling: 3716,
      density: 6.77,
      electronegativity: 1.12,
      radius: '',
      valence: '',
      specificheat: 0.192,
      comment: '',
    },
    {
      name: 'praseodymium',
      symbol: 'Pr',
      groupName: 'lanthanoid',
      number: 59,
      mass: 140.90766,
      period: 6,
      group: '',
      melting: 1208,
      boiling: 3793,
      density: 6.773,
      electronegativity: 1.13,
      radius: '',
      valence: '',
      specificheat: 0.193,
      comment: '',
    },
    {
      name: 'neodymium',
      symbol: 'Nd',
      groupName: 'lanthanoid',
      number: 60,
      mass: 144.242,
      period: 6,
      group: '',
      melting: 1297,
      boiling: 3347,
      density: 7.007,
      electronegativity: 1.14,
      radius: '',
      valence: '',
      specificheat: 0.19,
      comment: '',
    },
    {
      name: 'promethium',
      symbol: 'Pm',
      groupName: 'lanthanoid',
      number: 61,
      mass: 145,
      period: 6,
      group: '',
      melting: 1315,
      boiling: 3273,
      density: 7.26,
      electronegativity: 1.13,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'samarium',
      symbol: 'Sm',
      groupName: 'lanthanoid',
      number: 62,
      mass: 150.36,
      period: 6,
      group: '',
      melting: 1345,
      boiling: 2067,
      density: 7.52,
      electronegativity: 1.17,
      radius: '',
      valence: '',
      specificheat: 0.197,
      comment: '',
    },
    {
      name: 'europium',
      symbol: 'Eu',
      groupName: 'lanthanoid',
      number: 63,
      mass: 151.964,
      period: 6,
      group: '',
      melting: 1099,
      boiling: 1802,
      density: 5.243,
      electronegativity: 1.2,
      radius: '',
      valence: '',
      specificheat: 0.182,
      comment: '',
    },
    {
      name: 'gadolinium',
      symbol: 'Gd',
      groupName: 'lanthanoid',
      number: 64,
      mass: 157.25,
      period: 6,
      group: '',
      melting: 1585,
      boiling: 3546,
      density: 7.895,
      electronegativity: 1.2,
      radius: '',
      valence: '',
      specificheat: 0.236,
      comment: '',
    },
    {
      name: 'terbium',
      symbol: 'Tb',
      groupName: 'lanthanoid',
      number: 65,
      mass: 158.92535,
      period: 6,
      group: '',
      melting: 1629,
      boiling: 3503,
      density: 8.229,
      electronegativity: 1.2,
      radius: '',
      valence: '',
      specificheat: 0.182,
      comment: '',
    },
    {
      name: 'dysprosium',
      symbol: 'Dy',
      groupName: 'lanthanoid',
      number: 66,
      mass: 162.5,
      period: 6,
      group: '',
      melting: 1680,
      boiling: 2840,
      density: 8.55,
      electronegativity: 1.22,
      radius: '',
      valence: '',
      specificheat: 0.17,
      comment: '',
    },
    {
      name: 'holmium',
      symbol: 'Ho',
      groupName: 'lanthanoid',
      number: 67,
      mass: 164.93033,
      period: 6,
      group: '',
      melting: 1734,
      boiling: 2993,
      density: 8.795,
      electronegativity: 1.23,
      radius: '',
      valence: '',
      specificheat: 0.165,
      comment: '',
    },
    {
      name: 'erbium',
      symbol: 'Er',
      groupName: 'lanthanoid',
      number: 68,
      mass: 167.259,
      period: 6,
      group: '',
      melting: 1802,
      boiling: 3141,
      density: 9.066,
      electronegativity: 1.24,
      radius: '',
      valence: '',
      specificheat: 0.168,
      comment: '',
    },
    {
      name: 'thulium',
      symbol: 'Tm',
      groupName: 'lanthanoid',
      number: 69,
      mass: 168.9342,
      period: 6,
      group: '',
      melting: 1818,
      boiling: 2223,
      density: 9.321,
      electronegativity: 1.25,
      radius: '',
      valence: '',
      specificheat: 0.16,
      comment: '',
    },
    {
      name: 'ytterbium',
      symbol: 'Yb',
      groupName: 'lanthanoid',
      number: 70,
      mass: 173.045,
      period: 6,
      group: '',
      melting: 1097,
      boiling: 1469,
      density: 6.965,
      electronegativity: 1.1,
      radius: '',
      valence: '',
      specificheat: 0.155,
      comment: '',
    },
    {
      name: 'lutetium',
      symbol: 'Lu',
      groupName: 'lanthanoid',
      number: 71,
      mass: 174.9668,
      period: 6,
      group: 3,
      melting: 1925,
      boiling: 3675,
      density: 9.84,
      electronegativity: 1.27,
      radius: '',
      valence: '',
      specificheat: 0.154,
      comment: '',
    },
    {
      name: 'hafnium',
      symbol: 'Hf',
      groupName: 'transition-metal',
      number: 72,
      mass: 178.49,
      period: 6,
      group: 4,
      melting: 2506,
      boiling: 4876,
      density: 13.31,
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: 0.1444,
      comment: '',
    },
    {
      name: 'tantalum',
      symbol: 'Ta',
      groupName: 'transition-metal',
      number: 73,
      mass: 180.94788,
      period: 6,
      group: 5,
      melting: 3290,
      boiling: 5731,
      density: 16.654,
      electronegativity: 1.5,
      radius: '',
      valence: '',
      specificheat: 0.14,
      comment: '',
    },
    {
      name: 'tungsten',
      symbol: 'W',
      groupName: 'transition-metal',
      number: 74,
      mass: 183.84,
      period: 6,
      group: 6,
      melting: 3290,
      boiling: 5731,
      density: 16.654,
      electronegativity: 1.5,
      radius: '',
      valence: '',
      specificheat: 0.14,
      comment: '',
    },
    {
      name: 'rhenium',
      symbol: 'Re',
      groupName: 'transition-metal',
      number: 75,
      mass: 186.207,
      period: 6,
      group: 7,
      melting: 3459,
      boiling: 5869,
      density: 21.02,
      electronegativity: 1.9,
      radius: '',
      valence: '',
      specificheat: 1.37,
      comment: '',
    },
    {
      name: 'osmium',
      symbol: 'Os',
      groupName: 'transition-metal',
      number: 76,
      mass: 190.23,
      period: 6,
      group: 8,
      melting: 3306,
      boiling: 5285,
      density: 22.61,
      electronegativity: 2.2,
      radius: '',
      valence: '',
      specificheat: 0.13,
      comment: '',
    },
    {
      name: 'iridium',
      symbol: 'Ir',
      groupName: 'transition-metal',
      number: 77,
      mass: 192.217,
      period: 6,
      group: 9,
      melting: 2719,
      boiling: 4701,
      density: 22.56,
      electronegativity: 2.2,
      radius: '',
      valence: '',
      specificheat: 0.131,
      comment: '',
    },
    {
      name: 'platinum',
      symbol: 'Pt',
      groupName: 'transition-metal',
      number: 78,
      mass: 195.084,
      period: 6,
      group: 10,
      melting: 2041.4,
      boiling: 4098,
      density: 21.46,
      electronegativity: 2.28,
      radius: '',
      valence: '',
      specificheat: 0.133,
      comment: '',
    },
    {
      name: 'gold',
      symbol: 'Au',
      groupName: 'transition-metal',
      number: 79,
      mass: 196.966569,
      period: 6,
      group: 11,
      melting: 1337.33,
      boiling: 3129,
      density: 19.282,
      electronegativity: 2.54,
      radius: '',
      valence: '',
      specificheat: 0.129,
      comment: '',
    },
    {
      name: 'mercury',
      symbol: 'Hg',
      groupName: 'transition-metal',
      number: 80,
      mass: 200.592,
      period: 6,
      group: 12,
      melting: 234.43,
      boiling: 629.88,
      density: 13.5336,
      electronegativity: 2,
      radius: '',
      valence: '',
      specificheat: 0.14,
      comment: '',
    },
    {
      name: 'thalium',
      symbol: 'Tl',
      groupName: 'post-transition-metal',
      number: 81,
      mass: 204.38,
      period: 6,
      group: 13,
      melting: 577,
      boiling: 1746,
      density: 11.85,
      electronegativity: 1.62,
      radius: '',
      valence: '',
      specificheat: 0.129,
      comment: '',
    },
    {
      name: 'lead',
      symbol: 'Pb',
      groupName: 'post-transition-metal',
      number: 82,
      mass: 207.2,
      period: 6,
      group: 14,
      melting: 600.61,
      boiling: 2022,
      density: 11.342,
      electronegativity: 1.87,
      radius: '',
      valence: '',
      specificheat: 0.129,
      comment: '',
    },
    {
      name: 'bismuth',
      symbol: 'Bi',
      groupName: 'post-transition-metal',
      number: 83,
      mass: 208.9804,
      period: 6,
      group: 15,
      melting: 544.7,
      boiling: 1837,
      density: 9.807,
      electronegativity: 2.02,
      radius: '',
      valence: '',
      specificheat: 0.122,
      comment: '',
    },
    {
      name: 'polonium',
      symbol: 'Po',
      groupName: 'metalloid',
      number: 84,
      mass: 209,
      period: 6,
      group: 16,
      melting: 527,
      boiling: 1235,
      density: 9.32,
      electronegativity: 2.0,
      radius: '',
      valence: '',
      specificheat: 0.125,
      comment: '',
    },
    {
      name: 'astatine',
      symbol: 'At',
      groupName: 'halogen',
      number: 85,
      mass: 210,
      period: 6,
      group: 17,
      melting: 575,
      boiling: 610,
      density: 7,
      electronegativity: 2.2,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'radon',
      symbol: 'Rn',
      groupName: 'noble-gas',
      number: 86,
      mass: 222,
      period: 6,
      group: 18,
      melting: 202,
      boiling: 211.3,
      density: 0.00973,
      electronegativity: 2.2,
      radius: '',
      valence: '',
      specificheat: 0.094,
      comment: '',
    },
    {
      name: 'francium',
      symbol: 'Fr',
      groupName: 'alkali-metal',
      number: 87,
      mass: 223,
      period: 7,
      group: 1,
      melting: 300,
      boiling: 950,
      density: 1.87,
      electronegativity: 0.7,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'radium',
      symbol: 'Ra',
      groupName: 'alkaline-earth-metal',
      number: 88,
      mass: 226,
      period: 7,
      group: 2,
      melting: 973,
      boiling: 2010,
      density: 5.5,
      electronegativity: 0.9,
      radius: '',
      valence: '',
      specificheat: 0.094,
      comment: '',
    },
    {
      name: 'actinium',
      symbol: 'Ac',
      groupName: 'actinoid',
      number: 89,
      mass: 227,
      period: 7,
      group: '',
      melting: 1323,
      boiling: 3471,
      density: 10.07,
      electronegativity: 1.1,
      radius: '',
      valence: '',
      specificheat: 0.12,
      comment: '',
    },
    {
      name: 'thorium',
      symbol: 'Th',
      groupName: 'actinoid',
      number: 90,
      mass: 232.0377,
      period: 7,
      group: '',
      melting: 2115,
      boiling: 5061,
      density: 11.72,
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: 0.113,
      comment: '',
    },
    {
      name: 'protactinium',
      symbol: 'Pa',
      groupName: 'actinoid',
      number: 91,
      mass: 231.03588,
      period: 7,
      group: '',
      melting: 1841,
      boiling: 4300,
      density: 15.37,
      electronegativity: 1.5,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'uranium',
      symbol: 'U',
      groupName: 'actinoid',
      number: 92,
      mass: 238.02891,
      period: 7,
      group: '',
      melting: 1405.3,
      boiling: 4404,
      density: 18.95,
      electronegativity: 1.38,
      radius: '',
      valence: '',
      specificheat: 0.116,
      comment: '',
    },
    {
      name: 'neptunium',
      symbol: 'Np',
      groupName: 'actinoid',
      number: 93,
      mass: 237,
      period: 7,
      group: '',
      melting: 917,
      boiling: 4273,
      density: 20.45,
      electronegativity: 1.36,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'plutonium',
      symbol: 'Pu',
      groupName: 'actinoid',
      number: 94,
      mass: 244,
      period: 7,
      group: '',
      melting: 912.5,
      boiling: 3501,
      density: 19.84,
      electronegativity: 1.28,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'americium',
      symbol: 'Am',
      groupName: 'actinoid',
      number: 95,
      mass: 243,
      period: 7,
      group: '',
      melting: 1449,
      boiling: 2880,
      density: 13.69,
      electronegativity: 1.13,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'curium',
      symbol: 'Cm',
      groupName: 'actinoid',
      number: 96,
      mass: 247,
      period: 7,
      group: '',
      melting: 1613,
      boiling: 3383,
      density: 13.51,
      electronegativity: 1.28,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'berkelium',
      symbol: 'Bk',
      groupName: 'actinoid',
      number: 97,
      mass: 247,
      period: 7,
      group: '',
      melting: 1259,
      boiling: 2900,
      density: 14.79,
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'californium',
      symbol: 'Cf',
      groupName: 'actinoid',
      number: 98,
      mass: 251,
      period: 7,
      group: '',
      melting: 1173,
      boiling: 1743,
      density: 15.1,
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'einsteinium',
      symbol: 'Es',
      groupName: 'actinoid',
      number: 99,
      mass: 252,
      period: 7,
      group: '',
      melting: 1133,
      boiling: 1269,
      density: 8.84,
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'fermium',
      symbol: 'Fm',
      groupName: 'actinoid',
      number: 100,
      mass: 257,
      period: 7,
      group: '',
      melting: 1125,
      boiling: '',
      density: '',
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'mendelevium',
      symbol: 'Md',
      groupName: 'actinoid',
      number: 101,
      mass: 258,
      period: 7,
      group: '',
      melting: 1100,
      boiling: '',
      density: '',
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'nobelium',
      symbol: 'No',
      groupName: 'actinoid',
      number: 102,
      mass: 259,
      period: 7,
      group: '',
      melting: 1100,
      boiling: '',
      density: '',
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'lawrencium',
      symbol: 'Lr',
      groupName: 'actinoid',
      number: 103,
      mass: 262,
      period: 7,
      group: 3,
      melting: 1900,
      boiling: '',
      density: '',
      electronegativity: 1.3,
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'rutherforium',
      symbol: 'Rf',
      groupName: 'transition-metal',
      number: 104,
      mass: 267,
      period: 7,
      group: 4,
      melting: 2400,
      boiling: 5800,
      density: 23.2,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'dubnium',
      symbol: 'Db',
      groupName: 'transition-metal',
      number: 105,
      mass: 270,
      period: 7,
      group: 5,
      melting: '',
      boiling: '',
      density: 29.3,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'seaborgium',
      symbol: 'Sg',
      groupName: 'transition-metal',
      number: 106,
      mass: 269,
      period: 7,
      group: 6,
      melting: '',
      boiling: '',
      density: 35,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'bohrium',
      symbol: 'Bh',
      groupName: 'transition-metal',
      number: 107,
      mass: 270,
      period: 7,
      group: 7,
      melting: '',
      boiling: '',
      density: 37.1,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'hassium',
      symbol: 'Hs',
      groupName: 'transition-metal',
      number: 108,
      mass: 270,
      period: 7,
      group: 8,
      melting: '',
      boiling: '',
      density: 40.7,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'meitnerium',
      symbol: 'Mt',
      groupName: 'transition-metal',
      number: 109,
      mass: 278,
      period: 7,
      group: 9,
      melting: '',
      boiling: '',
      density: 37.4,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'darmstadtium',
      symbol: 'Ds',
      groupName: 'transition-metal',
      number: 110,
      mass: 281,
      period: 7,
      group: 10,
      melting: '',
      boiling: '',
      density: 34.8,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'roentgenium',
      symbol: 'Rg',
      groupName: 'transition-metal',
      number: 111,
      mass: 281,
      period: 7,
      group: 11,
      melting: '',
      boiling: '',
      density: 28.7,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'copernicium',
      symbol: 'Cn',
      groupName: 'transition-metal',
      number: 112,
      mass: 285,
      period: 7,
      group: 12,
      melting: '',
      boiling: 357,
      density: 23.7,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'nihonium',
      symbol: 'Nh',
      groupName: 'post-transition-metal',
      number: 113,
      mass: 286,
      period: 7,
      group: 13,
      melting: 700,
      boiling: 1400,
      density: 16,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'flerovium',
      symbol: 'Fl',
      groupName: 'post-transition-metal',
      number: 114,
      mass: 289,
      period: 7,
      group: 14,
      melting: 340,
      boiling: 420,
      density: 14,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'moscovium',
      symbol: 'Mc',
      groupName: 'post-transition-metal',
      number: 115,
      mass: 289,
      period: 7,
      group: 15,
      melting: 700,
      boiling: 1400,
      density: 13.5,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'livermorium',
      symbol: 'Lv',
      groupName: 'post-transition-metal',
      number: 116,
      mass: 293,
      period: 7,
      group: 16,
      melting: 708.5,
      boiling: 1085,
      density: 12.9,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'tennessine',
      symbol: 'Ts',
      groupName: 'halogen',
      number: 117,
      mass: 293,
      period: 7,
      group: 17,
      melting: 673,
      boiling: 823,
      density: 7.2,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
    {
      name: 'oganesson',
      symbol: 'Og',
      groupName: 'noble-gas',
      number: 118,
      mass: 294,
      period: 7,
      group: 18,
      melting: 258,
      boiling: 263,
      density: 5,
      electronegativity: '',
      radius: '',
      valence: '',
      specificheat: '',
      comment: '',
    },
  ];
}
